// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status1[data-v-53fe14df]{color:#67c23a}.status2[data-v-53fe14df]{color:#f56c6c}.thsj-tj[data-v-53fe14df]{font-size:16px}.text-title[data-v-53fe14df]{margin-top:6px;color:rgba(0,0,0,.5);display:block}.title[data-v-53fe14df]{border-right:1px solid rgba(0,0,0,.1);padding:15px 10px 0 10px}.bnd[data-v-53fe14df]{position:absolute;top:-9px;color:rgba(0,0,0,.5)}.col-999[data-v-53fe14df]{color:#999}.overflow[data-v-53fe14df]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
